import React, { useEffect, useState } from "react";
import PopUpPanel from "../../../PopUpPanel/PopUpPanel";
import ImageUploader2 from "../../../forms/ImageUpload/ImageUploader2";

const TemporaryImageUploadPopup = (props) => {
    return (
        <PopUpPanel closePanelFunc={props.closePanelFunc}>
            <div className="form-holder co-popup-content">
                <h2>Upload Image</h2>
                    <ImageUploader2
                        id={"temporary-image-upload"}
                        currentFile={props.varVal?.srcUrl || ""}
                        fileSelectedCallback={
                            (data) => { 
                                console.log('TemporaryImageUploadPopup fileSelectedCallback', data);
                                if (data.originalEvent !== 'removed') {
                                    const fileData = data.file;
                                    // Create a blob url for the uploaded file
                                    const blobUrl = URL.createObjectURL(fileData);
                                    props.varVal.srcUrl = blobUrl;
                                    props.varVal.selectedFile = fileData;
                                    props.varVal.originalFile = fileData.name;
                                    // That's all we need to do here as we are not going to actually upload this image now, we will handle it properly later
                                    // (this is only a temporary image upload and we are not saving our data yet)
                                    props.onComplete?.();
                                } 
                            }
                        }
                        // removedCallback={() => removeVal(valsArray, index)}
                        showZoomOption={false}
                        // zoomFunction={props.zoomFunction}
                        showRemoveOption={false}
                        showLabel={true}
                        label={props.controlLabel}
                        labelNote={props.labelNote}
                    />
            </div>
        </PopUpPanel>
    );
};

export default TemporaryImageUploadPopup;